import { useEffect, useState } from "react"
import { FormControlLabel, Switch } from "@mui/material"
import { cn } from "../../lib/utils.js"
import { useNavigation } from "../../hooks/use-navigation.js"
import { Info } from "lucide-react"
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip.js"
import {
  getNewLayoutPreference,
  setNewLayoutPreference,
  subscribeToNewLayoutPreference,
} from "../../utils/layout-preference.js"

export function NewLayoutToggle({ collapsed, isMobile }) {
  const { navigateWithLoading } = useNavigation()
  const [useNewLayout, setUseNewLayout] = useState(getNewLayoutPreference)

  useEffect(() => {
    const handlePreferenceChange = () => {
      setUseNewLayout(getNewLayoutPreference())
    }

    return subscribeToNewLayoutPreference(handlePreferenceChange)
  }, [])

  const handleToggle = (event) => {
    const nextValue = event.target.checked
    setUseNewLayout(nextValue)

    setNewLayoutPreference(nextValue)

    navigateWithLoading(
      nextValue ? "/vendas" : "/listSale",
      nextValue ? "Carregando novo layout..." : "Carregando layout clássico...",
      { replace: true }
    )
  }

  return (
    <div
      className={cn(
        "px-3 py-2",
        collapsed && !isMobile ? "text-center" : ""
      )}
    >
      <FormControlLabel
        className="!m-0 w-full"
        labelPlacement={collapsed && !isMobile ? "top" : "start"}
        control={
          <Tooltip>
            <TooltipTrigger>
              <Switch
                size="small"
                color="info"
                checked={useNewLayout}
                onChange={handleToggle}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#90caf9"
                  },
                  "& .MuiSwitch-switchBase:not(.Mui-checked) + .MuiSwitch-track": {
                    backgroundColor: "#424242"
                  },
                  "& .MuiSwitch-switchBase:not(.Mui-checked) .MuiSwitch-thumb": {
                    backgroundColor: "#9e9e9e"
                  }
                }}
              />
            </TooltipTrigger>
            <TooltipContent>
              Ative para usar o layout atualizado
            </TooltipContent>
          </Tooltip>
        }
        label={
          <div className={cn(
            "flex gap-2 text-xs text-gray-300",
            collapsed && !isMobile ? "items-center" : ""
          )}>
            <span className="font-semibold text-white">Novo Layout</span>
          </div>
        }
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: collapsed && !isMobile ? "center" : "space-between",
          alignItems: "center",
          flexDirection: collapsed && !isMobile ? "column" : "row",
          gap: 1
        }}
      />
    </div>
  )
}
